import {
  CORRECTED_RESULT_LABEL,
  isCorrectedResult,
  isSupersededResult,
  SUPERSEDED_RESULT_LABEL,
} from "../../utils/resultCorrection";
import styles from "./ResultCorrectionBadge.module.css";

/*
 * Says, in a list row, that this result corrects an earlier one or has itself been replaced
 * (KIN-2089). Renders nothing for the ordinary result, which is almost every row.
 *
 * A result can only be one or the other at a time from the reader's point of view: a correction
 * that was itself corrected matters as a replaced result, so that is what wins.
 */
export const ResultCorrectionBadge = ({ result }) => {
  if (isSupersededResult(result))
    return (
      <span className={`${styles.badge} ${styles.superseded}`}>
        {SUPERSEDED_RESULT_LABEL}
      </span>
    );

  if (isCorrectedResult(result))
    return (
      <span className={`${styles.badge} ${styles.corrected}`}>
        {CORRECTED_RESULT_LABEL}
      </span>
    );

  return null;
};
